module.exports = __webpack_public_path__ + "img/image (20).b953a680.jpg";